import { ListData } from '../../../components/items-list/list-data.service';
import { Injector } from '@angular/core';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '../../../components/items-list/items-list-header';
import { ObjectTypes } from '../../../shared/types';
import { IFormReportActiveColleague } from '../fi-form-report';
import { UserListProfileIconColumnComponent } from '../../../user/user-list/user-list-profile-icon-column/user-list-profile-icon-column.component';

export class FormReportActiveColleaguesListData extends ListData<IFormReportActiveColleague> {
    constructor(injector: Injector, reportItemClickCallback: (item: IFormReportActiveColleague) => void) {
        super(injector, true);

        this.MultiSelect = false;
        this.ShowDelete = false;
        this.ShowCheckAll = false;
        this.ShowCheckBox = false;
        this.CanShowLoadMore = false;
        this.ObjectType = ObjectTypes.Form;
        this.ChildProperty = 'AnswerSets';

        this.Header.push(
            new ItemsListHeader(
                '',
                '',
                new ItemsListHeaderProperties(
                    'CcmListItem-Icon CcmListItem-NoBorder',
                    true,
                    UserListProfileIconColumnComponent,
                ),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('colleague'),
                'FullName',
                new ItemsListHeaderProperties('CcmListItem-Name CcmListItem-NoBorder', true, ItemsListElementType.A, {
                    onClick: ($event, data: IFormReportActiveColleague) => {
                        $event.stopPropagation();
                        reportItemClickCallback(data);
                    },
                }),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.area'),
                'AreaName',
                new ItemsListHeaderProperties(
                    'CcmListItem-NoBorder CcmList-Column-ShowAlways',
                    true,
                    ItemsListElementType.SpanPlain,
                    { isRightAligned: true },
                ),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.unit'),
                'BusinessUnitName',
                new ItemsListHeaderProperties(
                    'CcmListItem-NoBorder CcmList-Column-ShowAlways',
                    true,
                    ItemsListElementType.SpanPlain,
                    { isRightAligned: true },
                ),
            ),
        );

        // TODO: Last submission
        // this.Header.push(new ItemsListHeader(this.appTextService.get('form.last_submission'), '',
        //     new ItemsListHeaderProperties('CcmList-Column-Narrow CcmListItem-NoBorder', false, ItemsListElementType.SpanPlain, {isRightAligned: true})
        // ));
    }
}
